const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      const formEmbedElement = document.querySelector('form-embed');

      if (formEmbedElement) {
        const shadowRoot = formEmbedElement.shadowRoot;

        if (shadowRoot) {

          const formElement = shadowRoot.querySelector('._formFieldset_cit2d_82');
          const containerAppRouter = shadowRoot.querySelector('._container_3eyaa_70');

          if (containerAppRouter) {
            const btnOpenForm = shadowRoot.querySelectorAll('button._teaserContainer_ou4pe_5');
            

            btnOpenForm.forEach(buttonopen => {
              buttonopen.style.cssText = `
                  border-radius:0px !important;
                `;
            });
          }

          if (formElement) {
            const formFileInputFields = formElement.querySelectorAll('input');
            const formFieldButtons = formElement.querySelectorAll('button');
            const formDivs = shadowRoot.querySelectorAll('._gridItem_stahb_172._imageLoaded_stahb_241');
            const formGeneral = shadowRoot.querySelector('._formContainer_1q1d2_30');

            formFileInputFields.forEach(inputField => {
              inputField.style.cssText = `
                  border-radius:0px !important;
                `;
            });

            formFieldButtons.forEach(button => {
              button.style.cssText = `
                  border-radius:0px !important;
                `;
            });

            formGeneral.style.cssText = `
                  border-radius:0px !important;
                `;


            formDivs.forEach(container => {
              container.style.cssText = `${container.style.cssText}; border-radius: 0px !important;`;
            });
          }

          // Seleccionar el botón con clase a.mox-custom-trigger
          const triggerButton = document.querySelector('a.mox-custom-trigger');

          if (triggerButton) {
            triggerButton.addEventListener('click', function (event) {
              event.preventDefault(); // Prevenir comportamiento por defecto (por ejemplo, abrir un modal)


              // Buscar dentro de #app-embed un botón con clase que contenga "teaserContainer"
              const teaserButton = shadowRoot.querySelector('[class*="teaserContainer"]');
              if (teaserButton) {
                teaserButton.click(); // Simular el click
              } else {
                console.warn('No se encontró el botón con clase "teaserContainer" dentro de #app-embed.');
              }

            });
          } else {
            console.warn('No se encontró el botón trigger con clase "footer-block-title subscribe-modal-trigger".');
          }


        }
      }
    }
  });
});


observer.observe(document.body, { childList: true, subtree: true });



